export default __webpack_public_path__ + "static/media/litho-landing-page-icon-04.b0e24cf1.jpg";